import { httpClient } from '../../config';
import { getSelectedIndustryId } from '../industryUtils';

export const fetchUniqueGoals = async () => {
  try {
    const industryId = getSelectedIndustryId();
    const { json } = await httpClient(`/tables/active_entities/unique_goals?industry_id=${industryId}`);
    return json;
  } catch (error) {
    console.error('Failed to fetch goals data:', error);
    throw error;
  }
};
